// TOP LEVEL IMPORTS
import React from 'react';
import { withRouter } from 'react-router-dom';
// ANTD
import Row from 'components/common/Row';
import Table from 'components/common/Table';
import Col from 'components/common/Col';
// COMPONENTS
import columns from './columns';
import OrganizationsSearchInput from 'components/inputs/OrganizationsSearchInput';
// import DownloadCSV from '../../../components/common/DownloadCSV';
// REDUX

class AdminUsersTable extends React.Component {
  onOrganizationSelect = organization => {
    this.props.history.push(`/admin/organization/${organization._id}`);
  };

  render() {
    return (
      <div>
        <Row type="flex" gutter={20} align="middle" justify="center" style={{ marginBottom: 5 }}>
          <Col xs={16}>
            <OrganizationsSearchInput onChange={this.onOrganizationSelect} />
          </Col>
          <Col xs={8} />
        </Row>

        <Table rowKey={record => record._id} columns={columns} dataSource={this.props.organizations} />
      </div>
    );
  }
}

export default withRouter(AdminUsersTable);



// WEBPACK FOOTER //
// ./src/routes/admin-organizations/OrganizationsTable/index.js